import LogoPlaceholder from "./logo-placeholder.png";
import Slide1 from "./preview/slide-1.png";
import Slide2 from "./preview/slide-2.png";
import Slide3 from "./preview/slide-3.png";
import Slide4 from "./preview/slide-4.png";
import Logo from "./logo.png";
import BgOption1 from "./../images/bg-option-1.png";
import BgOption2 from "./../images/bg-option-2.png";
import BgOption3 from "./../images/bg-option-3.png";
import { MultilineView, TextView } from "../../components";
import BaseTemplate from "../base";

class Advanced extends BaseTemplate {
  constructor() {
    super();
    this.id = "2";
    this.name = "Basic #2";
    this.description =
      "Create an engaging carousel that showcases your personal brand";
    this.url = "/ai/carousels/advanced";
    this.common_settings = {
      elements: [
        {
          label: "Your Name",
          type: "text",
          value: "Supergrow",
        },
        {
          label: "Profile Pic (JPG or PNG 256x256px)",
          type: "logo",
          key: "logo",
          value: {
            type: "image",
            image: Logo,
          },
        },
        {
          label: "Handle",
          type: "text",
          value: "@supergrow",
        },
        {
          label: "Background",
          type: "background",
          key: "background_color",
          value: {
            type: "color",
            image: "",
            color: "#0BA5EC",
            color_options: [
              "#2cd4bf",
              "#38bcf7",
              "#feb022",
              "#f87066",
              "#33d583",
              "#818cf8",
              "#f471b6",
              "#bf84fc",
            ],
            image_options: [
              {
                image: BgOption1,
              },
              {
                image: BgOption2,
              },
              {
                image: BgOption3,
              },
            ],
          },
        },
        {
          label: "Primary Color",
          type: "color",
          key: "primary_color",
          style_key_group: "primary",
          value: "#FFFFFF",
        },
        {
          label: "Secondry Color",
          type: "color",
          key: "secondary_color",
          style_key_group: "secondary",
          value: "#0BA5EC",
        },
        {
          label: "Primary Font",
          key: "primary_font",
          value: "Archivo Black",
          type: "font",
        },
        {
          label: "Secondary Font",
          key: "secondary_font",
          value: "Archivo",
          type: "font",
        },
      ],
      swipe_indicator: {
        image: "",
      },
    };
    this.preview_images = [Slide1, Slide2, Slide3, Slide4];
    this.slides = [
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Let’s turn your web article to a LinkedIn post",
            max_words: 8,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "48px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
        ],
        slide_type: "intro",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            value: "Paste your article",
            type: "text",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Read an interesting article that you want to share with your LinkedIn audience?

We've got you covered. Simply copy the link and paste the link to “Article to LinkedIn post” template inside Supergrow.

Note: The link should be public and accessible by anyone`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Select the format",
            max_words: 5,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "36px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
          {
            label: "Description",
            target_key: "description",
            type: "multiline",
            value: `Once you paste the link, select your preferred format.

You can select from 10+ formats available at your fingertips to help you create visually appealing LinkedIn posts.

Your audience will love to simply love to read your posts.`,
            max_words: 25,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "14px",
              },
              fontFamily: {
                key: "secondary_font",
              },
              fontWeight: {
                value: "400",
              },
            },
          },
        ],
        slide_type: "middle",
      },
      {
        elements: [
          {
            label: "Title",
            target_key: "title",
            type: "text",
            value: "Try it out & let us know your feedback",
            max_words: 7,
            style: {
              color: {
                key: "primary_color",
              },
              fontSize: {
                value: "48px",
              },
              fontFamily: {
                key: "primary_font",
              },
            },
          },
        ],
        slide_type: "outro",
      },
    ];
  }

  setCommonSettings(settings) {
    this.common_settings = settings;
  }

  getPrimaryColor(commonSettings) {
    return commonSettings.elements[4].value;
  }

  getSecondaryColor(commonSettings) {
    return commonSettings.elements[5].value;
  }

  duplicateSlide(slide, index) {
    let new_slide = JSON.parse(JSON.stringify(slide));
    if (index === 0) {
      let el = {
        label: "Description",
        target_key: "description",
        value: "",
      };
      new_slide.elements.push(el);
    }

    this.slides.splice(index + 1, 0, new_slide);
    return new_slide;
  }

  renderSlide(
    slide,
    index,
    currentSlide,
    carouselLength,
    commonSettings,
    updateSlideElementPosition,
    updateSlideElementSize,
    setCurrentSlideElement,
    previewMode
  ) {
    return (
      <div
        key={index}
        className={
          "carousel-slide-container ring-1 ring-gray-200 bg-white relative shrink-0 aspect-[4/5] flex flex-col w-[400px] h-[500px] overflow-hidden " +
          (index !== currentSlide ? "hidden" : "") +
          " index-" +
          index
        }
      >
        <div className="absolute inset-0">
          {commonSettings.elements[3]?.value.type === "image" && (
            <img
              className="object-cover w-full h-full"
              src={commonSettings.elements[3]?.value.image}
              alt=""
            />
          )}
          {commonSettings.elements[3].value.type === "color" && (
            <div
              className="w-full h-full"
              style={{
                backgroundColor: commonSettings.elements[3]?.value.color,
              }}
            ></div>
          )}
        </div>
        <div className="z-10 pt-10 pb-8 pl-8">
          <div className="flex items-center">
            <div
              className="inline-flex items-center justify-center w-10 h-10 text-lg font-semibold rounded-full"
              style={{
                color: this.getPrimaryColor(commonSettings),
                border: "2px solid " + this.getPrimaryColor(commonSettings),
              }}
            >
              {index < 9 ? "0" + (index + 1) : index + 1}
            </div>
            <div
              className="w-full flex-1 min-w-0 h-0.5"
              style={{ backgroundColor: this.getPrimaryColor(commonSettings) }}
            ></div>
          </div>
        </div>

        {index === 0 && (
          <>
            <div className="z-10 flex-1 px-8">
              <div
                className="text-[48px] leading-none tracking-tight font-archivo"
                style={{ color: this.getPrimaryColor(commonSettings) }}
              >
                {slide.elements[0]?.style ? (
                  <MultilineView
                    element={slide.elements[0]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, commonSettings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, commonSettings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[0]?.value} />
                )}
              </div>
            </div>
          </>
        )}
        {index === carouselLength - 1 && (
          <>
            <div className="z-10 flex-1 px-8">
              <div
                className="text-[48px] leading-none tracking-tight font-archivo"
                style={{ color: this.getPrimaryColor(commonSettings) }}
              >
                {slide.elements[0]?.style ? (
                  <MultilineView
                    element={slide.elements[0]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, commonSettings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, commonSettings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[0]?.value} />
                )}
              </div>
            </div>
          </>
        )}
        {index !== carouselLength - 1 && index !== 0 && (
          <>
            <div className="relative flex-1 px-8">
              <div
                className="text-[36px] leading-none font-archivo"
                style={{ color: this.getPrimaryColor(commonSettings) }}
              >
                {slide.elements[0]?.style ? (
                  <MultilineView
                    element={slide.elements[0]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, commonSettings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, commonSettings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[0]?.value} />
                )}
              </div>
              <div
                className="mt-4 text-sm font-normal"
                style={{ color: this.getPrimaryColor(commonSettings) }}
              >
                {slide.elements[1]?.style ? (
                  <MultilineView
                    element={slide.elements[1]}
                    getPropertyByStyleKey={(styleKey) =>
                      this.getPropertyByStyleKey(styleKey, commonSettings)
                    }
                    getValueByKey={(key) =>
                      this.getValueByKey(key, commonSettings)
                    }
                  />
                ) : (
                  <TextView text={slide.elements[1]?.value} />
                )}
              </div>
            </div>
          </>
        )}
        <div className="z-10 flex items-center justify-between gap-6 px-8 pb-8 mt-auto shrink-0">
          <div className="flex items-center gap-3">
            <img
              className="object-cover w-12 h-12 rounded-full shrink-0"
              src={
                commonSettings.elements[1]?.value.image !== ""
                  ? commonSettings.elements[1]?.value.image
                  : LogoPlaceholder
              }
              alt=""
            />
            <div>
              <p
                className="text-sm font-semibold"
                style={{ color: this.getPrimaryColor(commonSettings) }}
              >
                <TextView text={commonSettings.elements[0]?.value} />
              </p>
              <p
                className="text-sm font-normal"
                style={{ color: this.getPrimaryColor(commonSettings) }}
              >
                <TextView text={commonSettings.elements[2]?.value} />
              </p>
            </div>
          </div>

          <div
            className="inline-flex items-center justify-center gap-1.5 px-3 py-1 text-sm font-bold tracking-tight text-blue-500 rounded-full"
            style={{
              color: this.getSecondaryColor(commonSettings),
              backgroundColor: this.getPrimaryColor(commonSettings),
            }}
          >
            {index === carouselLength - 1
              ? slide.elements[1]?.value
              : "Swipe right"}
            {index !== carouselLength - 1 && (
              <svg
                aria-hidden="true"
                className="w-4 h-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            )}
            {index === carouselLength - 1 && (
              <svg
                aria-hidden="true"
                className="w-4 h-4"
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 20 20"
                fill="currentColor"
              >
                <path
                  fillRule="evenodd"
                  d="M16.707 10.293a1 1 0 010 1.414l-6 6a1 1 0 01-1.414 0l-6-6a1 1 0 111.414-1.414L9 14.586V3a1 1 0 012 0v11.586l4.293-4.293a1 1 0 011.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </div>
        </div>
      </div>
    );
  }
}

export default Advanced;
